<div class="opp-list">
    <div class="row">
        <div class="col-12">
            <div style="font-size:11px;line-height:16.5px;font-weight:400;font-family:Poppins;color:#989AA3 !important;"
                class="breadcrumbfont">
                <sd-breadcrumb
                    [data]="{'breadcrumb':[{'name':'Faq', 'link': '/faq'}, {'name': 'Distribute Guide'}], 'version':2}">
                </sd-breadcrumb>
                <sd-content-banner class='block m-t-20'></sd-content-banner>
            </div>
        </div>
    </div>
    <div class="search-section  d-flex align-items-center">
        <div class="icon col-lg-2 col-md-4" *ngIf="!global.isMobile()">
            <img class="img-fluid" src="../../assets/images/Cloud Upload.svg" alt="" srcset="">
        </div>
        <div class="header col-lg-6 col-md-8 ">
            <h2>Distribution Guide</h2>
            <p class="mt-3">Need help in uploading your release? Find the step-by-step guide to distributing with
                Songdew.</p>
        </div>
    </div>

    <p class="caption w-lg-75 ml-lg-5 ml-0">Releasing your music on Songdew is the easiest step in getting your music
        heard by
        millions
        of
        listeners.
        <br>
        <br>
        It is essentially a four step process
    </p>

    <div class="d-flex flex-wrap justify-content-around px-lg-5 mt-4">
        <div class="step d-flex mb-3 col-lg-5">
            <div class="icon">
                <img class="img-fluid" src="../../assets/qna/1.png" width="120">

            </div>
            <div class="p-3">
                <span>STEP I</span>
                <p>Log on to Songdew</p>


            </div>
        </div>
        <div class="step d-flex mb-3 col-lg-5">
            <div class="icon">
                <img class="img-fluid" src="../../assets/qna/2.png" width="120">

            </div>
            <div class="p-3">
                <span>STEP II</span>
                <p>Subscribe To Songdew</p>


            </div>
        </div>
        <div class="step d-flex mb-3 col-lg-5">
            <div class="icon">
                <img class="img-fluid" src="../../assets/qna/3.png" width="120">

            </div>
            <div class="p-3">
                <span>STEP III</span>
                <p>Choose what you want to distribute</p>


            </div>
        </div>
        <div class="step d-flex mb-3 col-lg-5">
            <div class="icon">
                <img class="img-fluid" src="../../assets/qna/4.png" width="120">

            </div>
            <div class="p-3">
                <span>STEP IV</span>
                <p>Fill The Distribution Form</p>


            </div>
        </div>
    </div>
    <div class="container px-lg-5 px-0">
        <h3 class="subHeading">
            Choose What you want to release
        </h3>
            <p class="mt-2"> <span class="subTitle">New Release </span>-  Distribute a brand-new Project</p>
            <p class="mt-2"> <span class="subTitle">Transfer Release  </span>– Move your previously released Project to Songdew.</p>
            <img src="../../assets/qna/release.png" class="img-fluid mx-lg-5 my-3">
            <p style="font-size: 16px !important; color: #2222228C;">After selecting New Release or Transfer Release, you can choose whether your project is a Single or an Album.</p>
            <img src="../../assets/qna/SongAlbum.png" class="img-fluid mx-lg-5 my-3 shadow ">
            <p style="font-size: 16px !important; color: #2222228C;">After selecting Single or Album, you can proceed to fill out the distribution form.</p>
    </div>
    <div class="container px-lg-5 px-0">
        <h3 class="subHeading">
            The Distribution Form
        </h3>
        <p class="caption">Here’s a step by step guide to filling the distribution form and what does each field mean
        </p>
        <div class="d-flex flex-wrap justify-content-center mb-4 mt-5">
            <a (click)="navigateTo('release_details')" class="nav-link d-inline-block badge  mx-lg-3 mr-1"
                [ngClass]="{'badge__active':tab=='release_details'}">RELEASE
                DETAILS</a>
            <a (click)="navigateTo('track_details')" class="nav-link d-inline-block badge mx-lg-3 mr-1"
                [ngClass]="{'badge__active':tab=='track_details'}">TRACK DETAILS</a>
            <a (click)="navigateTo('art_work')" class="nav-link d-inline-block badge mx-lg-3 mr-1"
                [ngClass]="{'badge__active':tab=='art_work'}">ARTWORK</a>
            <a (click)="navigateTo('scheduling')" class="nav-link d-inline-block badge mx-lg-3 mr-1"
                [ngClass]="{'badge__active':tab=='scheduling'}">SCHEDULING</a>
            <a (click)="navigateTo('agreement')" class="nav-link d-inline-block badge mx-lg-3 mr-1"
                [ngClass]="{'badge__active':tab=='agreement'}">AGREEMENT</a>
        </div>

        <div id="release_details" class="container px-lg-5 px-0" *ngIf="tab=='release_details'">
            <h4 class="subTitle">
                Release Title:
            </h4>
            <p class="mt-2">Enter the Title of your release</p>
            <p>Note:</p>
            <ul>
                <li>Release Name is Case Sensitive: The way you type the name of your release is how it would appear on
                    all
                    streaming platforms.</li>
                <li>Please write only the release name. Do not suffix it with any other tag.</li>
                <ul class="column-list">
                    <li><img src="../../assets/subscription/round-blue-tick.svg" width="13px" class="mr-2">Dilbar</li>
                    <li><img src="../../assets/images/cross.svg" class="mr-2">Dilbar ft. Nora Fatehi</li>
                    <li><img src="../../assets/subscription/round-blue-tick.svg" width="13px" class="mr-2">Baarishein
                    </li>
                    <li><img src="../../assets/images/cross.svg" class="mr-2">Baarishein - Acoustic</li>
                </ul>

            </ul>
            <img src="../../assets/qna/release_title.png" class="img-fluid mx-lg-5 my-5">
            <h4 class="subTitle mt-4">
                Version:
            </h4>
            <p>Version can be used to enter the following: </p>
            <ul>
                <li>Type Of Release: Cover/ Remix/ Acoustic/ Live</li>
                <li>In case you are releasing a single which is a part of an album, use this space to enter the name of
                    the
                    album. </li>
            </ul>
            <h4 class="subTitle">
                Adding An Artist:
            </h4>
            <p class="mt-3">
                <span class="heading3">Primary Artist:</span>
                The name of Primary Artist is picked directly from your Profile.
            </p>
            <p class="mt-2">NOTE: </p>
            <ul>
                <li> To ensure your profile is linked to your correct Spotify/ Apple Profile, please link your profile
                    by
                    sharing the URL for both Apple and Spotify Profiles. </li>
                <li>We would try to ensure that the rest of the platforms get linked to the correct profile
                    automatically.
                </li>
                <li>For YouTube, however, a Topic Channel would be created for the release. The channel can be merged
                    with
                    your
                    OAC after the release.</li>
            </ul>
            <img src="../../assets/qna/pmArtist1.png" class="img-fluid mx-lg-5 my-3">

            <p class="mt-3">
                <span class="heading3"> Another Artist:</span>
                If you want to add more artists to your release, then click on ‘Add Another Artist’.
            </p>
            <p class="mt-2">NOTE: </p>
            <ul>
                <li> There is no difference between Primary and Another Artists on platform. Both artists are shown as
                    artists
                    who have contributed to the release. </li>
                <li>Please mention only those artists on whose profile you would want this track to be visible. </li>
                <img src="../../assets/qna/song.png" class="img-fluid mx-lg-5 mt-3">
                <li class="mt-3"> Both Primary and Another Artists would appear in this manner on streaming platforms.
                </li>
                <li>If more than 3 artists are tagged on a particular song, it showcases as ‘Various Artists’ on Apple
                    Music.
                </li>
                <li>Do ensure to share the correct profiles while adding an artist. </li>
            </ul>
            <p class="mt-3"> <span class="heading3">Featured Artist:</span>
                If there is an artist who is a guest feature on your track/ album, then you can add him/ her under
                ‘Featured
                Artist’. To do this, just click on ‘Add Featured Artist’ and fill the required information.
            </p>
        </div>
        <div id="track_details" class="container px-lg-5 px-0" *ngIf="tab=='track_details'">


            <h4 class="subTitle">
                Uploading Your Music:
            </h4>
            <p>Click on "Select File to Upload" or drag and drop the audio file into the designated area.</p>
            <p>Note:</p>
            <ul>
                <li>Supported Formats : .wav</li>
                <li>File Size: 200 MB</li>
            </ul>

            <img class="img-fluid my-3" src="../../../assets/qna/track_details_1.png" alt="track_details">

            <h4 class="subTitle">
                Track Information:
            </h4>


            <p class="mt-2">Enter the following details in a manner which best describe your track:</p>

            <ul>
                <li>Is this an Instrumental track?</li>
                <ul class="">
                    <li>Select <strong>Yes</strong> if your track has no vocals. Language will be set to Instrumental automatically, and the Lyrics, Lyricist, Language field will be hidden. </li>
                    <li>Select <strong>No</strong> if your track has vocals and proceed to fill in the Language and Lyrics fields.  </li>
                </ul>
                <li>Genre</li>
                <li>SubGenre</li>
                <li>Language</li>
                <ul class="">
                    <li>If your track has multiple languages, use the one that has been used in majority. </li>
                </ul>
                <li>Year of Production </li>
                <li>Lyrics</li>
                <ul class="">
                    <li>You can only use Roman Script while entering your lyrics. i.e., If you have a track in Hindi,
                        you will still have to enter lyrics in English Script eg.: Baarishein Hain Baarishein </li>
                    <li>You cannot use special characters like <,> and while entering lyrics</li>
                    <li>The lyrics entered are used for promotional purposes and also for distributing to Apple Music.
                        Lyrics for Instagram and Spotify would have to be entered by the artist directly. </li>
                    <img src="../../assets/qna/newFile.png" class="img-fluid mx-lg-5 my-5">

                </ul>
                <li>
                    Do not forget to mark the Explicit Tag if your lyrics contain cuss words or language that is
                    deemed sexual, offensive ro violent.
                </li>
            </ul>
            <h4 class="subTitle">
                Artist Credits:
            </h4>
            <p>All artists who have contributed in making your release a reality can be credited through this section.
                The credits section has the option for following: </p>
            <ul>
                <li>Lyricist</li>
                <li>Composer</li>
                <li>Producer</li>
                <li>Arranger</li>
                <li>Remixer</li>
            </ul>
            Note:
            <ul>
                <li>

                    Credits made here would not be reflected as mail artists, but would be shown under Artist Credits
                    like below:
                </li>
                <img class="my-3" src="../../assets/qna/credits.png" alt="credits">

                <li>Please use legal names and not stage names for each artist</li>
                <ul class="column-list">
                    <li> <img src="../../assets/subscription/round-blue-tick.svg" width="13px" class="mr-2"> Samayukh
                        Sinha</li>
                    <li> <img src="../../assets/images/cross.svg" class="mr-2"> Samayukh </li>
                    <li> <img src="../../assets/subscription/round-blue-tick.svg" width="13px" class="mr-2"> Himadara
                        Pandey</li>
                    <li> <img src="../../assets/images/cross.svg" class="mr-2"> Mr. Pro</li>

                </ul>
                <li>In case an entire band is involved in production/ writing/ composition of a track, names of each
                    individual member is to be written in the credits</li>
                <ul class="column-list">
                    <li> <img src="../../assets/images/cross.svg" class="mr-2">Kabir Cafe</li>
                    <li> <img src="../../assets/subscription/round-blue-tick.svg" width="13px" class="mr-2">Mukund
                        Ramaswamy, Neeraj Arya, Britto KC, Viren Solanki, Raman Iyer </li>
                </ul>
                <li>On Spotify, both the Lyricist and Composers will be credited under the ‘Written By’ Section.</li>
            </ul>






            <h4 class="subTitle">
                Platform Requirements
            </h4>
            <p class="mt-3"><span class="heading3">CRBT:</span>
                CRBT Time Stamp refers to the time band which you would want to make into a caller tune.
                A caller tune is 30 seconds long. You can select the portion of your track which you deem fit to become
                the Caller Tune through this section. To select the section, just enter the time stamp where you want
                the caller tune to begin.</p>

            <p class="mt-2">NOTE: </p>
            <ul>
                <li> CRBT cannot be changed once it is made live. </li>
            </ul>
            <p class="mt-3">
                <span class="heading3">YT Content ID:</span>
                YouTube provides a Content ID to every single song distributed on the platform. This enables to detect
                misuse of your track. Once the Content ID is enabled, if any user uploads your track on any channel,
                they would get a Copyright Claim and all revenue generated through the platform would be redirected to
                you.
                You can decide if you want to activate a Youtube Content ID for your release or now
            </p>

            <p class="mt-2">NOTE: </p>
            <ul>
                <li>Do not opt for a YouTube Content ID if you are using non exclusive rights to a beat in your track.
                </li>
            </ul>
            <p class="mt-3"><span>Type of Release:</span><br>
                Categorize your release into one of the following: </p>
            <ul>
                <li>Original Composition</li>
                <li>Cover</li>
                <li>Remix</li>
            </ul>
            <p class="mt-2">NOTE: </p>
            <ul>
                <li>To release a remix/ cover track, you would need an NOC/ permission from the original copyright
                    holder. </li>
            </ul>














        </div>
        <div id="art_work" class="container px-lg-5 px-0" *ngIf="tab=='art_work'">
            <h4 class="subTitle">
                Art Work:
            </h4>

            <p class="mt-2">Click on 'Upload Image' to select your artwork. Your artwork must meet the following
                requirements:</p>
            <img class="my-3 img-fluid shadow" src="../../assets/qna/art_work.png" alt="art_work">
            <ul>
                <li>Dimensions: 3000 px x 3000 px</li>
                <li>File Type: .jpg</li>
                <li>The artwork should not be pixelated.</li>
                <li>Release Title/ Artist/ Credits must exactly match the meta data</li>
                <li>The artwork should not have any extra information like </li>
                <ul class="">
                    <li> social media links</li>
                    <li> contact information </li>
                    <li> store names or logos</li>
                    <li> pricing information </li>
                    <li> release dates, etc. </li>
                </ul>
                <p class="mt-3" style="margin-left: -18px;">Note:</p>
                <li>It is not mandatory to have all credits on the artwork. </li>
                <li>It is recommended to stick to the following credits on the artwork</li>
                <ul class="">
                    <li> Title</li>
                    <li> Primary Artists</li>
                    <li> Featured Artists </li>
                </ul>
                <li>
                    Please avoid adding information regarding the people starring in the video on your artwork. Do not
                    credit.
                    <ul class="">
                        <li>Models</li>
                        <li>Actors</li>
                        <li>Directors</li>
                    </ul>
                    in the artwork
                </li>
            </ul>

        </div>
        <div id="scheduling" class="container px-lg-5 px-0" *ngIf="tab=='scheduling'">
            <h4 class="subTitle">
                Scheduling:
            </h4>

            <p class="mt-2"> <span class="heading3">New Release:</span>

                Pick your release date from the calendar to schedule your release.
            </p>
            <p>Note:
                <br>
                While you can pick any date 7 days from the date of upload, we suggest giving yourself at least 21 days
                to enable pre release promotion - including pitching the release to playlist curators, radio stations
                and creating hype on social media.
            </p>
            <img class="img-fluid shadow my-4" src="../../assets/qna/scheduling.png" alt="schedule">
            <p class="mt-2"> <span class="heading3">Transfer Release:</span>
                You can <strong>schedule your release</strong> on Songdew <strong>up to 15 days in advance. </strong>Make sure to choose a date that gives you enough time to map your streams. 
                <br>
            <img class="img-fluid shadow my-4" src="../../assets/qna/top.png" alt="schedule">


                <br>
                Points To Remember:
            </p>
            <ul>
                <li>If you want to retain the streams of your track, you must fill the meta data exactly ( the same
                    audio file, the same artwork, the same credits) as the track before. Even if you want to change
                    anything, those changes will be made once the re-released song is uploaded and your streams have
                    been saved. </li>
                <li>The track should be submitted and released before taking down the previous track</li>


            </ul>
            <p>Please Note: We will attempt to retain your streams but it is not 100% guaranteed. </p>
            <img class="img-fluid my-4 shadow" src="../../assets/qna/bottom.png" alt="scheduling">

            <p>While submitting a Transfer Release, you must fill the following details accurately: </p>
            <ul>
                <li> <strong>ISRC code</strong> of your track (from the earlier release)  </li>
                <li> <strong>UPC code</strong> of your previous release/project </li>
                <li> <strong>Original release </strong> date of the track  </li>
                <li> <strong>Platform(s)</strong> where the track was previously distributed  </li>
                <li> <strong>Gaana link,</strong>  if your track was earlier released on Gaana   </li>
            </ul>



        </div>
        <div id="agreement" class="container px-lg-5 px-0" *ngIf="tab=='agreement'">
            <h4 class="subTitle">
                Agreement:
            </h4>


            <p>This is the final step to getting your music distributed. Share the details below to get a digital
                agreement which will then get signed by verifying your OTP. <br>
                Basic Information: <br>
                Share the following information to help us generate your agreement</p>
            <ul>
                <li>Legal Name of the person who is signing the agreement</li>
                <li>Email Address and </li>
                <li>Phone Number </li>
            </ul>
            <p>Please ensure this data is correct. It is what would be used to reach you regarding your release.
            </p>
            <img class="img-fluid shadow my-4" src="../../assets/qna/agreement.png" alt="agreement">


            <p class="mt-3"><span class="heading3">Bank Information:</span>
                This information would be used to transfer royalties to you as and when they are due. Please be
                assured that we keep your information safe and secured and it would not be shared with anyone
                outside our accounts team. </p>
            <img class="img-fluid shadow my-4" src="../../assets/qna/bank_info.png" alt="account_details">
            <p>Required Information include: </p>
            <ul>
                <li> Bank Account Number </li>
                <li> Name of Account Holder </li>
                <li> IFSC Code</li>
                <li> Name of Bank</li>
            </ul>

        </div>

    </div>


    <sd-footer></sd-footer>
</div>
